import { z } from "zod";
import { conciergeIntakeRequestTypeValues, conciergeIntakeRequirementsSchema, } from "./concierge-intake.js";
// A staff member creates and submits a concierge request for a customer (CHT-2051, ADR 0018). The route is
// `POST /staff/customers/:customerId/concierge-requests`, in `apps/api/src/routes/staff-request-create-routes.ts`. The admin calls it only
// through `@lafayette/api-client` (`staff-request-create.ts`).
//
// The body is the customer's own: the same request types and the same requirement fields (`conciergeIntakeRequirementsSchema`), so the two
// paths cannot drift. The customer is the id in the path; a body that names a customer, an owner, a state or a source is refused (strict). The
// answer is small: the new request id and its state. The request page is where the staff member reads the rest.
export const staffCreateRequestBodySchema = z.strictObject({
    requestType: z.enum(conciergeIntakeRequestTypeValues),
    requirements: conciergeIntakeRequirementsSchema,
});
/** `SUBMITTED`: nobody could take it yet, a supervisor assigns it. `ASSIGNED`: the routing gave it to a concierge or the supervisor queue. */
export const staffCreatedRequestStateValues = ["SUBMITTED", "ASSIGNED"];
export const staffCreatedRequestSchema = z.strictObject({
    requestId: z.string().min(1).max(64),
    state: z.enum(staffCreatedRequestStateValues),
});
